module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/phone-6bfbab1c92f3c80e15f394e322409c8f.svg";